module.exports = "//static.hsappstatic.net/LoginUI/static-1.16032/img/SUI_desktop.svg"